<!-- HTML Part -->
<template>
  <div>
    <div class="card border-0 no-shadow bg-light mb-3">
      <div class="card-header border-0 bg-transparent">
        <h4>ข้อมูลตัวแทน/นายหน้า</h4>
        <br/>
        <b-spinner v-if="isLoading" class="align-middle mr-2"></b-spinner>
        <InsuranceForm
          v-if="!isLoading"
          title="ใบอนุญาตบัตรประกันวินาศภัย"
          :id="ins.id"
          licenseForm="NONLIFE"
          :fullName="ins.nlFullName"
          :type="ins.nlType"
          :licenseTypeName="ins.nlLicenseTypeName"
          :typeCode="ins.nlTypeCode"
          :compCode="ins.nlCompCode"
          :compName="ins.nlCompName"
          :isExpired="ins.nlExpired"
          :no="ins.nlNo"
          :exp="ins.nlExp"
          :expF="ins.nlExpF"
          :trHrs="ins.nlTrHrs"
          :card="ins.nlCard"
          :opt="nlOpt"
          :nlReducedHours="ins.nlReducedHours"
          :nlLevel="ins.nlLevel"
          :firstName="firstName"
          :lastName="lastName"
          @edit="edit($event, 'nl')"
          @getIns="getIns()"
        />
        <br/>
        <br/>
        <InsuranceForm
          v-if="!isLoading"
          title="ใบอนุญาตบัตรประกันชีวิต"
          :id="ins.id"
          licenseForm="LIFE"
          :fullName="ins.lFullName"
          :type="ins.lType"
          :licenseTypeName="ins.lLicenseTypeName"
          :typeCode="ins.lTypeCode"
          :compCode="ins.lCompCode"
          :compName="ins.lCompName"
          :isExpired="ins.lExpired"
          :no="ins.lNo"
          :exp="ins.lExp"
          :expF="ins.lExpF"
          :trHrs="ins.lTrHrs"
          :card="ins.lCard"
          :opt="lOpt"
          :lReducedHours="ins.lReducedHours"
          :lLevel="ins.lLevel"
          :firstName="firstName"
          :lastName="lastName"
          @edit="edit($event, 'l')"
          @getIns="getIns()"
        />
      </div>
    </div>
  </div>
</template>

<!-- Javascript Part -->
<script>
//Import
//--Vue Component
import InsuranceForm from "./InsuranceForm.vue";
//--Js
import api from "@/services/api.js";
//Export
export default {
  //--Vue Component
  components: { InsuranceForm },
  props: { 
    firstName: { type: String, default: null },
    lastName: { type: String, default: null },
   },
  //--Two Ways Binding Data
  data() {
    return {
      //Global Datas
      mId: this.$route.params.id,
      //Non-Life Insurance License
      isLoading: true,
      nlOpt: [
        { label: "นายหน้าประกันวินาศภัย", value: "NONLIFE_BROKER" },
        { label: "ตัวแทนประกันวินาศภัย", value: "NONLIFE_AGENT" }
      ],
      lOpt: [
        { label: "นายหน้าประกันชีวิต", value: "LIFE_BROKER" },
        { label: "ตัวแทนประกันชีวิต", value: "LIFE_AGENT" }
      ],
      ins: {
        id: null,
        lCard: null,
        lExp: null,
        lExpF: null,
        lNo: null,
        lTrHrs: null,
        lType: null,
        lLicenseTypeName: null,
        nlLicenseTypeName: null,
        lLicenseIssuedAt: null,
        nlLicenseIssuedAt: null,
        lTypeCode: null,
        lFullName: null,
        lCompCode: null,
        lCompName: null,
        lExpired: null,
        nlCard: null,
        nlExp: null,
        nlExpF: null,
        nlNo: null,
        nlTrHrs: null,
        nlType: null,
        nlFullName: null,
        nlTypeCode: null,
        nlCompCode: null,
        nlCompName: null,
        nlExpired: null,
        lReducedHours: null,
        nlReducedHours: null,
        lLevel: null,
        nlLevel: null,
      }
    };
  },
  mounted() {
    this.getIns();
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr || typeof dateStr !== 'string' || !dateStr.includes('-')) return null;
      const [year, month, day] = dateStr.split('-');
      return `${day}/${month}/${year}`;
    },
      dateOnly(dateStr) {
      return new Date(dateStr).toISOString().split('T')[0];
    },
    async fetchLicenseData(licenseNo, type) {
      try {
        const { data } = await api.get(`v1/insurance-oic/${licenseNo}/data`);
        const d = data?.data;
        if (!d) return;

        const prefix = type; // 'l' หรือ 'nl'
        const ins = this.ins;

        ins[`${prefix}ExpF`] = this.formatDate(d.EXPIRE_DATE);
        ins[`${prefix}FullName`] = `${d.NAMES} ${d.LASTNAME}`;
        ins[`${prefix}TypeCode`] = d.LICENSE_TYPE_CODE;
        ins[`${prefix}LicenseTypeName`] = d.LICENSE_TYPE_NAME;
        ins[`${prefix}TypeName`] = d.LICENSE_TYPE_NAME;
        ins[`${prefix}LicenseIssuedAt`] = d.DATE_LICENSE_ACT;
        ins[`${prefix}Exp`] = d.EXPIRE_DATE;
        ins[`${prefix}CompCode`] = d.COMP_CODE;
        ins[`${prefix}CompName`] = d.COMP_NAME;
        ins[`${prefix}Expired`] = d.LICENSE_EXPIRED;
        ins[`${prefix}Level`] = d.LICENSE_LEVEL;

        // คำนวณประเภทใบอนุญาตและชั่วโมงอบรม
        const typeCode = d.LICENSE_TYPE_CODE;
        const level = d.LICENSE_LEVEL;
        let licenseType = '';
        let trHours = null;

        if (type === 'nl') {
          if (['02', '05', '06', '08'].includes(typeCode)) {
            licenseType = 'NONLIFE_AGENT';
            trHours = ['RENEW1', 'RENEW2', 'RENEW3'].includes(level) ? 6 : (level === 'RENEW4' ? 30 : null);
          } else if (typeCode === '04') {
            licenseType = 'NONLIFE_BROKER';
            trHours = ['RENEW1', 'RENEW2', 'RENEW3'].includes(level) ? 10 : (level === 'RENEW4' ? 50 : null);
          }
        } else if (type === 'l') {
          if (['01', '07'].includes(typeCode)) {
            licenseType = 'LIFE_AGENT';
            trHours = ['RENEW1', 'RENEW2', 'RENEW3'].includes(level) ? 6 : (level === 'RENEW4' ? 30 : null);
          } else if (typeCode === '03') {
            licenseType = 'LIFE_BROKER';
            trHours = ['RENEW1', 'RENEW2', 'RENEW3'].includes(level) ? 10 : (level === 'RENEW4' ? 50 : null);
          }
        }

        ins[`${prefix}Type`] = licenseType;
        ins[`${prefix}TrHrs`] = trHours;

      } catch (err) {
        console.warn(`Failed to load license data for ${licenseNo}`, err);
      }
    },
    async getIns() {
      await this.setNull();
      this.isLoading = true;

      try {
        const { data } = await api.get(`v1/insurance/${this.mId}`);
        this.ins = data || this.ins;

        const oldNlExp = this.ins.nlExp;
        const oldLExp = this.ins.lExp;

        if (this.ins.nlNo) {
          await this.fetchLicenseData(this.ins.nlNo, 'nl');
        }

        if (this.ins.lNo) {
          await this.fetchLicenseData(this.ins.lNo, 'l');
        }

        const isLExpChanged = oldLExp && this.ins.lExp &&
          this.dateOnly(oldLExp) !== this.dateOnly(this.ins.lExp);
        const isNlExpChanged = oldNlExp && this.ins.nlExp &&
          this.dateOnly(oldNlExp) !== this.dateOnly(this.ins.nlExp);

        if (isLExpChanged || isNlExpChanged) {
          await this.update(this.ins);
        }
      } catch (error) {
        return;
      } finally {
        this.isLoading = false;
      }
    },
    edit(input, type) {
      eval(`this.ins.${type}${input.name} = '${input.value}'`);
      this.update(this.ins);
    },
    async update(insuranceData) {
      await api
        .post(`/v1/insurance/${this.mId}/update`, {
          ins: insuranceData
        })
        .then(() => {
          this.getIns();
        });
    },
    setNull() {
      this.ins = {
        id: null,
        lCard: null,
        lExp: null,
        lNo: null,
        lTrHrs: null,
        lType: null,
        lTypeCode: null,
        nlCard: null,
        nlExp: null,
        nlNo: null,
        nlTrHrs: null,
        nlType: null,
        nlTypeCode: null,
        lReducedHours: null,
        nlReducedHours: null,
        lLevel: null,
        nlLevel: null,
      }
    }
  }
};
</script>

